import { useCallback } from "react";
import { isSupported } from "firebase/messaging";
import app from "../firebase";
import { getFcmTokenForApp } from "utils/firebaseMessaging";

/**
 * Custom hook for Firebase Cloud Messaging token management
 */
export const useFirebaseToken = () => {
  const getFcmToken = useCallback(async () => {
    return getFcmTokenForApp(app);
  }, []);

  const getTokenManageState = useCallback(
    async (getProfile, getCompanyInformation) => {
      // Use silent profile fetch so PROFILEREQUESTED does not flip Redux
      // isLoading. App.js replaces {children} with a full-page Loader when
      // isLoading is true, which remounts /offices after MFA login.
      const silent = { silent: true };
      try {
        let token = "";
        if (await isSupported()) {
          token = await getFcmToken();
        }

        getProfile(token, silent);
        getCompanyInformation();
      } catch (error) {
        console.error("Unable to register FCM token with profile:", error);
        getProfile("", silent);
        getCompanyInformation();
      }
    },
    [getFcmToken]
  );

  return {
    getFcmToken,
    getTokenManageState,
  };
};
